import { Components } from "appworks/components/components";
import { Services } from "appworks/services/services";
import { TGRMatrixComponent } from "components/tgr-matrix";
import { gameLayers } from "game-layers";
import { TGRSetupPartnerConnect } from "setup/tgr-setup-partner-connect";
import { TGRInit } from "states/tgr-init";
import { UpdateRandomMultipliersOnReelsets } from "tgr-utils";

export class DMFInit extends TGRInit {

    public onExit(): void {
        TGRSetupPartnerConnect();
        UpdateRandomMultipliersOnReelsets();
        Services.bet.onBetChange.add(() => UpdateRandomMultipliersOnReelsets());
        Components.get(TGRMatrixComponent).darkenReels(false, 0).execute();
        gameLayers.SymbolAnimations.enableBoundsMask(true);
    }
}
